import Schema from './Schema'
import FieldTableSelect from '../fields/FieldTableSelect'
export default class SchemaInput extends Schema {
  constructor(label, key, items, rules, options, on) {
    super(options)
    FieldTableSelect.call(this, label, key, items, rules, options, on)
  }
}


// WEBPACK FOOTER //
// ./packages/helper/schema/SchemaTableSelect.js